var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"unr-registration"}},[_c('v-main',[(_vm.isStepDistributor)?_c('distributor'):_vm._e(),(_vm.isStepRegistration)?_c('registration'):_vm._e()],1),_c('notifications',{attrs:{"group":"foo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }